import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import type { DecorationSet } from '@atlaskit/editor-prosemirror/view';

export type SlashRemixPlaceholderState = {
	decorations: DecorationSet;
	// Accepted plain-text instruction. Source capture and generation are connected separately.
	submittedPrompt?: { placeholderId: string; prompt: string };
};

export type RemixSlashFormat = 'bar-chart' | 'line-chart';

export type SlashRemixPlaceholderAction =
	| { format: RemixSlashFormat; type: 'open' }
	| { placeholderId?: string; type: 'remove' }
	| { placeholderId: string; prompt: string; type: 'submit' };

export const slashRemixPlaceholderKey: PluginKey<SlashRemixPlaceholderState> =
	new PluginKey<SlashRemixPlaceholderState>('slashRemixPlaceholder');
